import $ from 'jquery';
import breaky from 'breaky';
import './slick-carousel';
import './slick-slider';
import customPaging from './slick/custom-paging';
import registerJQueryPlugin from '../lib/register-jquery-plugin';
import mergeOptions from '../lib/merge-options';
import throttle from 'lodash/throttle';
// Expose the function as a jQuery plugin for ease of use
export const PLUGIN_NAME = 'recsPopOut';
export const DEFAULTS = {
	railTopMargin: 36,
	rail: '.product-recs--pop-out',
	pageContent: '.container--sb',
	backToTop: '.fixed-corner',
	header: '.site-header',
	headerBanner: '.global-banner',
	bannerSlider: '.banner--slider',
	footer: '.site-footer',
};

/**
 * Determines Top Margin of Rail
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
const updateTopMarginRail = ({
	header,
	railTopMargin,
	rail
}) => {
	const $rail = $(rail);
	const isRailActive = $rail.hasClass('active');
	const $recsContainer = $rail.closest('.js-recs-wrapper');
	const recentlyViwedIsLong = $recsContainer.find('.js-carousel--centered--ab').length;
	let marginTop = 0;
	if (isRailActive) {
		if(recentlyViwedIsLong) {
			const headerHeight = $(header).outerHeight();
			const bannersHeight = isHeaderFixed() ? 0 : $('header').position().top;
			marginTop = headerHeight + railTopMargin + bannersHeight;
		} else {
			marginTop = 60;
		}
	}

	$rail.css({
		marginTop
	});
}

/**
 * Get 'fixed' state of header element
 */
const isHeaderFixed = () => {
	return $('.js-fixed-header').hasClass('is-fixed');
}
/**
 * Updates Top Margin Based on Header
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
const updateRailTopPos = (opts) => {
	const header = $('.js-fixed-header');

	header.on('fixedHeader.fixed fixedHeader.static', () => {
		updateTopMarginRail(opts);
	});
}

/**
 * shows back to top
 * @param  {Object} [options={}] - Any options provided upon initialization
 * @param  {Object} {} - empty object
 */
const staticRail = (opts, railHedHeight) => {
	const footer = opts.footer;
	const $pagepageContent = $(opts.pageContent);
	const relativeClass = 'u-relative';
	const railAbsolute = 'product-recs--pop-out--absolute';
	const railAbsoluteReducedLeft = 'product-recs--pop-out--absolute-left';
	const $rail = $(opts.rail);
	// Added this for when rail is within a gc
	const $hasRailParent = $rail.closest('.js-recs-popout-container--center').length;


	$(window).on('scroll.railRecs resize.railRecs', throttle(() => {
		const footerTopPosition = $(footer).position().top;
		const windowHeight = $(window).height();
		const scrollPosition = $(window).scrollTop();
		const footerVisibleHeight = scrollPosition + windowHeight - footerTopPosition;
		const marginSpacing = opts.railTopMargin;

		if (footerVisibleHeight < 0) {
			// footer is not visible
			// rail is fixed
			railHedHeight.railHeight = $rail.height();
			$rail.removeClass(railAbsolute);
			$rail.css({
				'max-height': '100%'
			});
			$pagepageContent.removeClass(relativeClass);
			// footer is visible and has parent 'js-recs-popout-container--center', rail is fixed
			if ($hasRailParent && footerVisibleHeight < 0) {
				railHedHeight.railHeight = $rail.height();
				$rail.removeClass(railAbsoluteReducedLeft);
				$rail.css({
					'max-height': '100%'
				});
				$pagepageContent.removeClass(relativeClass);
			}
		} else {
			// footer is visible
			if (windowHeight < (footerTopPosition + marginSpacing) && footerTopPosition > -marginSpacing) {
				// footer is below the fold when window scroll top is 0
				$rail.css({
					'max-height': railHedHeight.railHeight + 35 // needs this 3...margin/padding ?
				});
				$rail.addClass(railAbsolute);
				$pagepageContent.addClass(relativeClass);
				// footer is visible and has parent 'js-recs-popout-container--center' and reduce left property to be closer to content
				if ($hasRailParent && windowHeight < (footerTopPosition + marginSpacing) && footerTopPosition > -marginSpacing) {
					$rail.css({
						'max-height': railHedHeight.railHeight
					});
					$rail.addClass(railAbsoluteReducedLeft);
					$rail.removeClass(railAbsolute);
					$pagepageContent.addClass(relativeClass);
				}
			} else {
				// footer is above the fold when window scroll top is 0
				$rail.css({
					'max-height': `calc(100% - ${marginSpacing}px - ${marginSpacing}px)`
				});
				$rail.addClass(railAbsolute);
				$pagepageContent.addClass(relativeClass);
				if ($hasRailParent) {
					$rail.css({
						'max-height': `calc(100% - ${marginSpacing}px - ${marginSpacing}px)`
					});
					$rail.removeClass(railAbsolute);
					$rail.addClass(railAbsoluteReducedLeft);
					$pagepageContent.addClass(relativeClass);
				}
			}
		}
	}, 70)).resize();
}
/**
 * Page content height to determine if the rail is absolute or fixed
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
const setRailType = (opts) => {
	// saving height to an obj. as user scrolls
	let railHedHeight = {};
	staticRail(opts, railHedHeight);
}

/**
 * Destroys slick slider and show recs on the right of page
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
const runAbove = ($recs, $rail, opts) => {
	const slickSliderExist = $recs.data('slickSlider');
	$rail.addClass('active');
	$recs.find('.js-carousel__track').removeClass('product-recs--slick-flex');
	if (slickSliderExist) {
		$recs.slickSlider('destroy');
	}
	updateTopMarginRail(opts);
	setRailType(opts);
}

/**
 * Show recs in page as a carousel
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
const runBelow = ($recs, $rail, opts) => {
	const $hasRailParent = $rail.closest('.js-recs-popout-container--center').length;
	$rail.removeClass('active');
	updateTopMarginRail(opts);
	$(window).off('.railRecs');
	if ($hasRailParent) {
		$recs.slickSlider({
			slidesToShow: 6,
			slidesToScroll: 6,
			responsive: [{
					breakpoint: 1199,
					settings: {
						slidesToShow: 4,
						slidesToScroll: 4,
					}
				},
				{
					breakpoint: 899,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 3,
					}
				}
			]
		});
		$recs.find('.js-carousel__track').addClass('product-recs--slick-flex');
	} else if ($rail.hasClass('js-popout-recs-b')) {
		$recs.slickSlider({
			customPaging,
			dots: true,
			dotsClass: "image-carousel__dots",
			appendDots: $(".image-carousel__dots-container"),
			slidesToShow: 4,
			slidesToScroll: 4,
		})
		$recs.find('.js-carousel__track').addClass('product-recs--slick-flex');
	} else {
		$recs.slickSlider({
			responsive: [{
				breakpoint: 899,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3,
				}
			}]
		});
	}
}


/**
 * Toggles between slick and rail depending browser width
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
const toggleRail = (breakpoint, $recs, $rail, opts) => {
	const $window = $(window);
	const initialWidth = $window.width();
	let isCarousel = initialWidth < breakpoint ? true : false;
	$(window).on('resize', function () {
		if (($window.width() >= breakpoint) && isCarousel === false) {
			isCarousel = true;
			runAbove($recs, $rail, opts);
			$(window).scroll();
		} else if (($window.width() <= breakpoint) && isCarousel === true) {
			isCarousel = false;
			runBelow($recs, $rail, opts);
		}
	}).resize();
}


/**
 * Set listeners depending on window width
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
const trackWindowSize = ($recs, opts) => {
	const $rail = $(opts.rail);
	if ($rail.hasClass('js-popout-recs-b')) {
		toggleRail(1026, $recs, $rail, opts);
	} else {
		toggleRail(1960, $recs, $rail, opts);
	}
	updateRailTopPos(opts);
	$(window).on('load', function () {
		updateTopMarginRail(opts);
		setRailType(opts);
	})
}


export default function recsPopOut(el, options = {}) {
	const $recs = $(el);
	const opts = mergeOptions(DEFAULTS, options, $recs);
	trackWindowSize($recs, opts);

	// update when cookie banner is closed
	$("#cookiesBar").on('closeCookieBanner', evt => {
		updateTopMarginRail(opts);
		setRailType(opts);
	});
}

// Expose the function as a jQuery plugin for ease of use
registerJQueryPlugin(PLUGIN_NAME, recsPopOut);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/recs-pop-out.js